export class CategoriesSettings {constructor(c={}) { 
  Object.assign(this, {

    titleFont: { fontSize: 14, fontWeight: '700', color: '#777777', fontFamily: 'arial, helvetica, sans-serif' },
    tableHeaderFont: { fontSize: 16, fontWeight: '700', color: '#333333', fontFamily: 'arial, helvetica, sans-serif' },
    tableBodyFont: { fontSize: 14, fontWeight: '400', color: '#555555', fontFamily: 'arial, helvetica, sans-serif' },
    useTitleFont: { fontSize: 16, fontWeight: '700', color: '#333333', fontFamily: 'arial, helvetica, sans-serif' },
    useFont: { fontSize: 14, fontWeight: '400', color: '#555555', fontFamily: 'arial, helvetica, sans-serif' },

    tableCellSpacing: { paddingLeft: 8, paddingRight: 8, paddingTop: 12, paddingBottom: 12 },
    categoriesText: 'Cookie Categories',
    descriptionText: 'Description',
    consentText: 'User Consent',
    liText: 'Legitimate Interest',

    categoriesUseText: 'Categories of Use', 

    linkConsentText: 'Manage options for Consent',
    linkLIText: 'Manage options for Legitimate Interest',
    link: { fontWeight: '400', color: '#1890ff', textDecoration: 'none' },
    hover: { fontWeight: '400', color: '#0880ef', textDecoration: 'underline' },

    toggleColor: '#47d747',
    toggleOffColor: '#cccccc',
    toggleNeutralColor: '#FFA800',
    toggleOnText: '',
    toggleOffText: '',

    languages: {},
    selectedLanguage: '',

  });
  Object.assign(this, c);
}}

export const CategoriesTypes = {
  'use settings': {
    categoriesUseText: { title: 'Categories of Use', type: 'InputLanguage' },
    useTitleFont: { title: 'Category Use Title Font', type: 'Font' },
    useFont: { title: 'Category Use Font', type: 'Font' },
  },
  'table settings': {
    tableCellSpacing: { title: 'Table Spacing', type: 'Padding' },
    titleFont: { title: 'Title Font', type: 'Font' },
    tableHeaderFont: { title: 'Table Header Font', type: 'Font' },
    tableBodyFont: { title: 'Table Body Font', type: 'Font' },
    categoriesText: { title: 'Cookie Categories', type: 'InputLanguage' },
    descriptionText: { title: 'Description', type: 'InputLanguage' },
    consentText: { title: 'User Consent', type: 'InputLanguage' },
    liText: { title: 'Legitimate Interest', type: 'InputLanguage' },
  },
  'link settings': {
    linkConsentText: { title: 'Link Consent', type: 'InputLanguage' },
    linkLIText: { title: 'Link Leg. Interest', type: 'InputLanguage' },
    link: { title: 'Link Style', type: 'Links' },
    hover: { title: 'Link Hover Style', type: 'Links' },
  },
  'toggle settings': {
    toggleColor: { title: 'ON Color', type: 'ColorPicker' },
    toggleOffColor: { title: 'OFF Color', type: 'ColorPicker' },
    toggleNeutralColor: { title: 'Neutral Color', type: 'ColorPicker' },
    toggleOnText: { title: 'Toggle ON Text', type: 'InputLanguage' },
    toggleOffText: { title: 'Toggle OFF Text', type: 'InputLanguage' },
  },
};
